import { createExposureSessionLatch } from './exposure-session-latch';

/** Latches order-pending-process-modal experiment exposures per Amplitude session. */
export const orderPendingProcessModalExposureSessionLatch = createExposureSessionLatch();
